<template>
  <div class="input-container">
    <label
      for="email"
      class="input__label"
    >E-mail address</label>
    <input
      id="email"
      v-model.lazy="$v.email.$model"
      class="input"
      :class="{'input--error' : ($v.email.$invalid === true && $v.email.$error === true)}"
      type="text"
      name="email"
      @focusout="updateEmail"
    >
    <span
      v-show="($v.email.$invalid === true && $v.email.$error === true)"
      class="input__error"
    >
      Invalid E-mail
    </span>
  </div>
</template>

<script>
import { required, email } from 'vuelidate/lib/validators'

export default {
  props: {
    emailProp: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      email: ''
    }
  },
  watch: {
    '$v.email.$invalid': function (val) {
      if (val === false) {
        this.$emit('input', this.email)
      }
      this.$emit('valid', (val === false), this.$options._componentTag)
    }
  },
  validations: {
    email: {
      required,
      email
    }
  },
  mounted () {
    if (this.emailProp) { this.email = this.emailProp }
  },
  methods: {
    updateEmail () {
      if (this.email.$invalid !== true && this.email.$error !== true) {
        this.$emit('input', this.email)
      }
    },
    triggerTouch () {
      this.$v.$touch()
    }
  }
}
</script>
